export default function ConvertToOption (data){
  if(Array.isArray(data)){
    return data.map( el => ({label:el, value: el}))
  }
  return {label: data, value: data}
}